import AuctionsTable from './component'

export default AuctionsTable
